export const INTERESTS_REDUCER_KEY = 'interests' as const;
export const PUSH_INTERESTS = 'PUSH_INTERESTS' as const;
export const REMOVE_INTERESTS = 'REMOVE_INTERESTS' as const;

export const JOB_TITLES_KEY = 'jobTitles' as const;
export const INDUSTRIES_KEY = 'industries' as const;
export const RESOURCE_TAGS_KEY = 'resourceTags' as const;
